import Model from '../orm/Model'
import i18n from '@/plugins/i18n'

export default class Rule extends Model {
    resourceName() {
        return 'rules'
    }

    fields() {
        return [
            'category_id',
            'max_value',
            'min_value',
            'rule_type',
            'type',
            'deleted_at',
        ]
    }

    appends() {
        return ['category_id']
    }

    aliases() {
        return {
            rule_type: 'type',
        }
    }

    computed() {
        return {
            active(category) {
                return category.deleted_at ? false : true
            },

            typeName(rule) {
                return i18n.t(`resources.rule.getters.type.${rule.type}`)
            },
        }
    }

    get availableTypes() {
        return [
            {
                value: 'customer',
                name: i18n.t(`resources.rule.getters.type.customer`),
            },
            {
                value: 'revenue',
                name: i18n.t(`resources.rule.getters.type.revenue`),
            },
        ]
    }

    get tableColumns() {
        return [
            {
                text: i18n.t('resources.rule.attributes.type'),
                value: 'typeName',
                sortable: false,
                align: 'center',
            },
            {
                text: i18n.t('resources.rule.attributes.min_value'),
                value: 'min_value',
                sortable: false,
                align: 'center',
            },
            {
                text: i18n.t('resources.rule.attributes.max_value'),
                value: 'max_value',
                sortable: false,
                align: 'center',
            },
            {
                text: i18n.t('resources.default.actions'),
                value: 'action',
                sortable: false,
                align: 'end',
            },
        ]
    }
}
